module.exports = __webpack_public_path__ + "assets/img/shu_09.4ddb8336.png";